/**
 * Eros PLP filter tray (ADR-205) - PURE price-row logic (no DOM, no network).
 * Three buckets from the terciles of the collection's own prices, rounded to thousands of the
 * shop currency (IQD). No slider. Loaded before eros-plp-tray-logic.js.
 */
(function (root) {
  'use strict';
  var ns = (root.ErosPlpTray = root.ErosPlpTray || {});

  function roundThousand(n) {
    return Math.round(n / 1000) * 1000;
  }

  /**
   * Three buckets by terciles of the collection's own prices, rounded to thousands.
   * prices: array of numbers (shop currency units); fallbackMax: S&D range max, used only when
   * there are too few prices to take terciles. Returns [] when no sane split exists.
   * Bucket = { gte: number|null, lte: number|null }.
   */
  function priceBuckets(prices, fallbackMax) {
    var p = [];
    for (var i = 0; i < (prices || []).length; i++) {
      var n = Number(prices[i]);
      if (isFinite(n) && n > 0) p.push(n);
    }
    p.sort(function (a, b) {
      return a - b;
    });
    var a;
    var b;
    if (p.length >= 6) {
      a = roundThousand(p[Math.floor(p.length / 3)]);
      b = roundThousand(p[Math.floor((2 * p.length) / 3)]);
    } else if (fallbackMax > 0) {
      a = roundThousand(fallbackMax / 3);
      b = roundThousand((2 * fallbackMax) / 3);
    } else {
      return [];
    }
    if (a < 1000) a = 1000;
    if (b <= a) b = a + 1000;
    var max = p.length ? p[p.length - 1] : fallbackMax;
    if (max && a >= max) return [];
    return [
      { gte: null, lte: a },
      { gte: a, lte: b },
      { gte: b, lte: null }
    ];
  }

  function sameNum(a, b) {
    if (a === null || a === '' || a === undefined) return b === null || b === '' || b === undefined;
    if (b === null || b === '' || b === undefined) return false;
    return Number(a) === Number(b);
  }

  function bucketActive(bucket, gte, lte) {
    return sameNum(bucket.gte, gte) && sameNum(bucket.lte, lte);
  }

  /** "Up to 25K" / "25-50K" / "Over 50K" label from the ui strings. */
  function bucketLabel(bucket, ui) {
    function fill(s, map) {
      return String(s || '').replace(/\{(\w+)\}/g, function (m, k) {
        return map[k] === undefined ? m : map[k];
      });
    }
    var k = function (n) {
      return String(Math.round(n / 1000));
    };
    if (bucket.gte === null) return fill(ui.price_up_to, { n: k(bucket.lte) });
    if (bucket.lte === null) return fill(ui.price_over, { n: k(bucket.gte) });
    return fill(ui.price_between, { a: k(bucket.gte), b: k(bucket.lte) });
  }

  /** Short text drawn inside the circle (the upper bound in thousands). */
  function bucketGlyph(bucket) {
    if (bucket.lte === null) return String(Math.round(bucket.gte / 1000)) + '+';
    return String(Math.round(bucket.lte / 1000));
  }

  /** Cheapest variant price of each product from /collections/x/products.json. */
  function pricesFromProductsJson(json) {
    var out = [];
    var products = (json && json.products) || [];
    for (var i = 0; i < products.length; i++) {
      var vs = products[i].variants || [];
      var min = null;
      for (var j = 0; j < vs.length; j++) {
        var n = Number(vs[j].price);
        if (isFinite(n) && n > 0 && (min === null || n < min)) min = n;
      }
      if (min !== null) out.push(min);
    }
    return out;
  }

  function chipLabel(f, ui) {
    var k = function (n) {
      return String(Math.round(Number(n) / 1000));
    };
    var lo = f.sg === '' ? null : Number(f.sg);
    var hi = f.sl === '' ? null : Number(f.sl);
    if (lo === null) return fill(ui.price_up_to, { n: k(hi) });
    if (hi === null) return fill(ui.price_over, { n: k(lo) });
    return fill(ui.price_between, { a: k(lo), b: k(hi) });
  }


  function fill(s, map) {
    return String(s || '').replace(/\{(\w+)\}/g, function (m, k) {
      return map[k] === undefined ? m : map[k];
    });
  }

  var api = {
    priceBuckets: priceBuckets,
    bucketActive: bucketActive,
    bucketLabel: bucketLabel,
    bucketGlyph: bucketGlyph,
    pricesFromProductsJson: pricesFromProductsJson,
    chipLabel: chipLabel
  };
  ns.price = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);
